export const CustomFieldType = {
    String: 'String',
    Dropdown: 'Dropdown',
}



// WEBPACK FOOTER //
// ./web/js/customFields/constants.js